import React, { useState, useEffect } from 'react';
import { SingleInput, SingleRedio, SingleCheck, SingleText } from '../../Res/BaseInput';
import { ContentBox } from '../ContentBox';
import { api_getSkill, api_addResumeOtherData } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { RespResumeOtherData, RespResumeOtherDataBase } from '../../../../item/ItemResume';
import { DatePickerInput } from 'rc-datepicker';
import moment from 'moment';
import { ListSelect } from '../../Res/ListSelect';
import { SubmitButton } from '../../Res/BaseButton';
import { getItemsInfo } from '../../../../item/ItemTools';

export const OtherData_base = "base"
/**
 * 
 * @param {Boolean} isEmployee 是否為內部員工
 * @param {Boolean} hosTools 是否顯示編輯按鈕
 */
export function ContractorResumeBase({ rId, idN, bDay, base, companyId, toSave, toEdit, isEdit, isEmployee = false, hosTools = true, setIsLoading, toDetial }) {
    const [resumeId, setResumeId] = useState("")
    const [employeeId, setEmployeeId] = useState("")
    const [enrollDate, setEnrollDate] = useState("")

    const [name, setName] = useState("")
    const [sex, setSex] = useState("")
    const [mobile, setMobile] = useState("")
    const [lineId, setLineId] = useState("")
    const [idNumber, setIdNumber] = useState("")
    const [birthday, setBirthday] = useState("")
    const [height, setHeight] = useState("")
    const [weight, setWeight] = useState("")
    const [marriage, setMarriage] = useState(0)
    const [military, setMilitary] = useState("")
    const [exMilitary, setExMilitary] = useState("")
    const [residentialAddress, setResidentialAddress] = useState("")
    const [mailingAddress, setmMailingAddress] = useState("")
    const [driverLicense, setDriverLicense] = useState([])
    const [transport, setTransport] = useState([])
    const [skills, setSkill] = useState([])
    const [otherSkill, setOtherSkill] = useState("")

    const [mBase, setBase] = useState({})
    const [skillList, setSkillList] = useState([])

    const [otherSkillBox, setOtherSkillBox] = useState(<></>)

    const [birthError, setBirthError] = useState(false)

    const marriageItems = [
        { "val": 1, "name": "未婚" },
        { "val": 2, "name": "已婚" },
        { "val": 3, "name": "不提供" }
    ]

    const militaryItems = [
        { "val": 1, "name": "未役" },
        { "val": 2, "name": "役畢" },
        { "val": 3, "name": "免役" }
    ]
    const driverLicenseItems = ["機車", "汽車"]
    const transportItems = ["機車", "汽車", "大眾運輸"]


    useEffect(() => {
        if (rId !== undefined && rId !== resumeId) {
            setResumeId(rId)
            getSkillList()
            //getResumeOtherData(rId, bDay)
        }
    }, [rId])

    useEffect(() => {
        if (idN !== undefined && idN !== idNumber) {
            setIdNumber(idN)
            //getResumeOtherData(rId, bDay)
        }
    }, [idN])

    useEffect(() => {
        if (bDay !== undefined && bDay !== birthday) {
            setBirthday(bDay)
            //getResumeOtherData(rId, bDay)
        }
    }, [bDay])

    useEffect(() => {
        // Object.keys(mBase).length === 0
        if (base !== undefined && base !== mBase && Object.keys(base).length !== 0) {
            setBase(base)
            //console.log(base.resumeData)
            var mRespResumeOtherDataBase = new RespResumeOtherDataBase({ resumeId, idNumber, birthday })
            if (base.resumeData !== undefined && base.resumeData !== null)
                mRespResumeOtherDataBase.fromJson(base.resumeData)
            //console.log(mRespResumeOtherDataBase)
            setEmployeeId(mRespResumeOtherDataBase.employeeId)
            setEnrollDate(mRespResumeOtherDataBase.enrollDate)

            setName(mRespResumeOtherDataBase.name)
            setSex(mRespResumeOtherDataBase.sex)
            setMobile(mRespResumeOtherDataBase.mobile)
            setLineId(mRespResumeOtherDataBase.lineId)
            setIdNumber(mRespResumeOtherDataBase.idNumber)
            console.log(mRespResumeOtherDataBase.birthday)
            if (mRespResumeOtherDataBase.birthday === "" || mRespResumeOtherDataBase.birthday === "Invalid date") {
                setBirthError(true)
            } else {
                setBirthday(moment(mRespResumeOtherDataBase.birthday).format('YYYY-MM-DD'))
            }
            setHeight(mRespResumeOtherDataBase.height)
            setWeight(mRespResumeOtherDataBase.weight)
            setMarriage(mRespResumeOtherDataBase.marriage)
            setMilitary(mRespResumeOtherDataBase.military)
            setExMilitary(mRespResumeOtherDataBase.exMilitary)
            setResidentialAddress(mRespResumeOtherDataBase.residentialAddress)
            setmMailingAddress(mRespResumeOtherDataBase.mailingAddress)
            setDriverLicense(mRespResumeOtherDataBase.driverLicense)
            setTransport(mRespResumeOtherDataBase.transport)
            setSkill(mRespResumeOtherDataBase.skills)
            setOtherSkill(mRespResumeOtherDataBase.otherSkill)
        }
    }, [base])


    /*
    function getResumeOtherData(resumeId, birthday){
        var mReqResumeOtherData = new ReqResumeOtherData({
            resumeId,
            resumeKey: OtherData_base
        })
        console.log(mReqResumeOtherData)
        api_getResumeOtherData({
            mReqResumeOtherData,
            success:(jsonData)=>{
                var mRespResumeOtherDataBase = new RespResumeOtherDataBase({resumeId, birthday})
                if(jsonData.info.resumeData !== undefined)
                    mRespResumeOtherDataBase.fromJson(jsonData.info.resumeData)
                setName(mRespResumeOtherDataBase.name)
                setSex(mRespResumeOtherDataBase.sex)
                setMobile(mRespResumeOtherDataBase.mobile)
                setLineId(mRespResumeOtherDataBase.lineId)
                setIdNumber(mRespResumeOtherDataBase.idNumber)
                setBirthday(moment(mRespResumeOtherDataBase.birthday).format('YYYY-MM-DD'))
                setHeight(mRespResumeOtherDataBase.height)
                setWeight(mRespResumeOtherDataBase.weight)
                setMarriage(mRespResumeOtherDataBase.marriage)
                setMilitary(mRespResumeOtherDataBase.military)
                setExMilitary(mRespResumeOtherDataBase.exMilitary)
                setResidentialAddress(mRespResumeOtherDataBase.residentialAddress)
                setmMailingAddress(mRespResumeOtherDataBase.mailingAddress)
                setDriverLicense(mRespResumeOtherDataBase.driverLicense)
                setTransport(mRespResumeOtherDataBase.transport)
                setSkill(mRespResumeOtherDataBase.skills)

                setBase(mRespResumeOtherDataBase)
            },
            failure:(err)=>{
            }
        })
    }
    */

    function getSkillList() {
        api_getSkill({
            success: (result) => {
                setSkillList(result.list)
            },
            failure: (err) => {

            }
        })
    }

    async function saveDetail() {
        if (birthError) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '生日 格式有誤, 請確認月日為2位數',
            })
            return
        }

        if(name === ""){
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '姓名不得為空白',
            })
            return
        }

        if (toSave !== undefined && birthday !== mBase.birthday) {
            toSave(birthday)
        }



        var base = new RespResumeOtherDataBase({
            resumeId,
            idNumber,
            employeeId,
            enrollDate,
            birthday,
            name,
            sex,
            mobile,
            lineId,
            height,
            weight,
            marriage,
            military,
            exMilitary,
            residentialAddress,
            mailingAddress,
            driverLicense,
            transport,
            skills,
            otherSkill,
            isEmployee: isEmployee
        })
        var mRespResumeOtherData = new RespResumeOtherData({
            companyId,
            resumeId,
            resumeKey: OtherData_base,
            resumeData: JSON.stringify(base),
        })
        mRespResumeOtherData.setNickName({ nickName: name, accountId: resumeId })
        setIsLoading(true)
        console.log("api_addResumeOtherData")
        api_addResumeOtherData({
            mRespResumeOtherData,
            isEmployee,
            success: (jsonData) => {
                console.log(jsonData)
                setIsLoading(false)
                Swal.fire({
                    type: 'success',
                    title: '儲存成功',
                    //text: '儲存成功',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: '繼續編輯',
                    cancelButtonText: '返回檢視',
                }).then(function (result) {
                    if (result.value) {
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        toDetial()
                    }
                })
            },
            failure: (err) => {
                setIsLoading(false)
                console.log(err)
                Swal.fire({
                    type: 'success',
                    title: '提醒',
                    text: "儲存失敗",
                })
            }
        })
    }


    const onChange = (jsDate, dateString) => {
        //console.log(jsDate)
        //console.log(dateString)
        if (dateString === "Invalid date") {
            setBirthError(true)
        } else {
            setBirthError(false)
            setBirthday(dateString)
        }
    }

    function setMilitaryChange(val) {
        setMilitary(val)
        if (val !== 3) {
            setExMilitary("")
        }
    }

    useEffect(() => {
        var other = getSkillName().filter(x => x === "其他")
        if (other.length > 0) {
            setOtherSkillBox(isEdit ?
                <SingleInput title={"其他專長"} val={otherSkill} action={setOtherSkill} placeholder={""} size={6} />
                : <SingleText title={"其他專長"} val={otherSkill} />
            )
        } else {
            setOtherSkill("")
            setOtherSkillBox(<></>)
        }
    }, [skills])

    function getSkillName() {
        //console.log(skillList)
        var names = []
        skills.map(skill => {
            var item = skillList.filter(x => x.skillId === skill)
            if (item.length > 0) {
                var name = item[0].skillName
                names.push(name)
            }
            return item
        })
        return names
    }

    var baseTitle = "職務資訊"
    var baseContent =
        <>
            <div className="row">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"姓名"} val={name} action={setName} placeholder={"王大同"} />
                        : <SingleText title={"姓名"} val={name} />
                    }
                    {isEdit ?
                        <SingleRedio title={"性別"} arr={[{ "val": 1, "name": "男" }, { "val": 2, "name": "女" }]} val={sex} action={setSex} />
                        : <SingleText title={"性別"} val={sex === 1 ? "男" : sex === 2 ? "女" : ""} />
                    }
                    {isEdit ?
                        <SingleInput title={"手機號碼"} val={mobile} action={setMobile} placeholder={"0988123456"} />
                        : <SingleText title={"手機號碼"} val={mobile} />
                    }
                    {isEdit ?
                        <SingleInput title={"Line ID"} val={lineId} action={setLineId} placeholder={"ABC123"} />
                        : <SingleText title={"Line ID"} val={lineId} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    <SingleText title={"身分證"} val={idNumber} />

                    {isEdit ?
                        <div className="col-md-3">
                            <p>生日</p>
                            <DatePickerInput
                                displayFormat='YYYY/MM/DD'
                                returnFormat='YYYY-MM-DD'
                                onChange={onChange}
                                value={birthday}
                                className='my-react-component'
                            />
                        </div>
                        : <SingleText title={"生日"} val={moment(birthday).format('YYYY/MM/DD')} />
                    }
                    {isEdit ?
                        <SingleInput title={"身高"} val={height} action={setHeight} placeholder={"176"} />
                        : <SingleText title={"身高"} val={height} />
                    }
                    {isEdit ?
                        <SingleInput title={"體重"} val={weight} action={setWeight} placeholder={"65"} />
                        : <SingleText title={"體重"} val={weight} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-lg-12">
                    {isEdit ?
                        <SingleRedio title={"婚姻狀態"}
                            arr={marriageItems}
                            val={marriage} action={setMarriage} />
                        : <SingleText title={"婚姻狀態"} val={getItemsInfo({ items: marriageItems, val: marriage })} />
                    }
                    {isEdit ?
                        <SingleRedio title={"兵役狀態"}
                            arr={militaryItems}
                            val={military} action={setMilitaryChange} />
                        : <SingleText title={"兵役狀態"} val={getItemsInfo({ items: militaryItems, val: military })} />
                    }
                    {military !== 3 ? <></> :
                        isEdit ?
                            <SingleInput title={""} val={exMilitary} action={setExMilitary} placeholder={"請提供原因"} size={6} />
                            : <SingleText title={"免役原因"} val={exMilitary} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"戶籍地址"} val={residentialAddress} action={setResidentialAddress} placeholder={"例：台北市中正區忠孝東路一段100號"} size={6} />
                        : <SingleText title={"戶籍地址"} val={residentialAddress} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row m-t-sm">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleInput title={"通訊地址"} val={mailingAddress} action={setmMailingAddress} placeholder={"例：台北市中正區忠孝東路一段100號"} size={6} />
                        : <SingleText title={"通訊地址"} val={mailingAddress} />
                    }
                </div>
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleCheck title={"駕照"} val={driverLicense} arr={driverLicenseItems} action={setDriverLicense} />
                        : <SingleText title={"駕照"} val={driverLicense.join("、")} />
                    }
                    {isEdit ?
                        <SingleCheck title={"交通工具"} val={transport} arr={transportItems} action={setTransport} />
                        : <SingleText title={"交通工具"} val={transport.join("、")} />
                    }
                </div>
            </div>

            <div className="hr-line-dashed"></div>

            {isEdit ?
                <ListSelect
                    title={"專長"}
                    ids={skills}
                    list={skillList}
                    sId={"skillId"}
                    sName={"skillName"}
                    setIds={setSkill}
                />
                : <SingleText title={"專長"} val={getSkillName().join("、")} size={12} />
            }

            <div className="row m-t-sm">
                <div className="col-md-12">
                    {otherSkillBox}
                </div>
            </div>
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row m-t-sm">
                        <div className="col-md-12">
                            <SubmitButton name={"儲存"} action={saveDetail} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>

    var title_tools =
        !hosTools ? <></> :
            isEdit ? <></> :
                <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toEdit()}>
                    <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">編輯</span>
                </a>
    return (
        <>
            <ContentBox title={baseTitle} content={baseContent} title_tools={title_tools} hasDrawer={isEdit ? true : false} />
        </>
    )
}